export default __webpack_public_path__ + "static/media/face.edd7dab7.gif";